module.exports = __webpack_public_path__ + "img/Spider Monitor.63dafcde.svg";